<template>
  <v-dialog v-model="dialog" width="400" persistent>
    <v-form @submit.prevent="handleSubmit">
      <v-card>
        <v-card-title>
          {{ title }}
          <v-spacer></v-spacer>
          <v-btn @click="close()" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-text-field
            v-model="input"
            :label="fieldLabel"
            :color="color"
            autofocus
            :clearable="optional"
            :placeholder="placeholder"
            v-if="mask"
            v-mask="mask"
          />

          <v-text-field
            v-else
            v-model="input"
            :label="fieldLabel"
            :color="color"
            autofocus
            :clearable="optional"
            :placeholder="placeholder"
          />
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="close()" text> Cancelar </v-btn>
          <v-btn
            type="submit"
            :color="color"
            :dark="!valid ? false : dark"
            :disabled="!valid"
          >
            Gravar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  mixins: [],

  components: {},

  props: {
    title: String,
    fieldLabel: String,
    color: {
      type: String,
      default: "primary",
    },
    dark: {
      type: String,
    },
    optional: Boolean,
    placeholder: String,
    mask: {
      type: [String, Array],
      default: null,
    },
  },

  data() {
    return {
      dialog: false,

      input: "",
    };
  },

  methods: {
    close() {
      this.dialog = false;
    },

    open(start = "") {
      this.dialog = true;
      this.input = start;
    },

    handleSubmit() {
      this.dialog = false;
      this.$emit("submit", this.input);
    },
  },

  computed: {
    valid() {
      if (this.optional) {
        return true;
      }

      if (this.input.length < 1) {
        return false;
      }

      return true;
    },
  },
};
</script>
